import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN || '';
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID || '';
const auth0RedirectUri = process.env.REACT_APP_AUTH0_REDIRECT_URI || `${window.location.origin}/`;
const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE || '';

const onRedirectCallback = (appState) => {
  const target = appState?.returnTo || '/';
  window.history.replaceState({}, document.title, target);
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      useRefreshTokens
      cacheLocation='localstorage'
      authorizationParams={{
        redirect_uri: auth0RedirectUri,
        audience: auth0Audience || undefined,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Auth0Provider>
  </React.StrictMode>,
);
